import { NavItem } from './nav-item/nav-item';

// Sidebar for non-admin users:
// - No "Add/Create" actions
// - No main settings section/routes
export const nonAdminItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'aperture',
    route: '/dashboard',
  },
  {
    displayName: 'Hubs',
    iconName: 'building-store',
    route: 'apps/hubs',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/hubs/list',
      },
    ],
  },
  {
    displayName: 'Products',
    iconName: 'package',
    route: 'apps/products',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/products/list',
      },
      {
        displayName: 'Categories',
        iconName: 'point',
        route: 'apps/products/categories/list',
      },
    ],
  },
  {
    displayName: 'Retailers',
    iconName: 'user-shield',
    route: 'apps/retailers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/retailers/list',
      },
    ],
  },
  {
    displayName: 'Orders',
    iconName: 'shopping-cart',
    route: 'apps/orders',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/orders/list',
      },
    ],
  },
  {
    displayName: 'Dispatch',
    iconName: 'truck-delivery',
    route: 'apps/dispatch',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/dispatch/list',
      },
    ],
  },
  {
    displayName: 'Stock Requisitions',
    iconName: 'file-check',
    route: 'apps/stock-requisitions',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/stock-requisitions/list',
      },
    ],
  },
  {
    displayName: 'Inventory',
    iconName: 'stack',
    route: 'apps/inventory',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/inventory/list',
      },
      {
        displayName: 'Transfers',
        iconName: 'point',
        route: 'apps/inventory/transfer/list',
      },
    ],
  },
  {
    displayName: 'Vehicles',
    iconName: 'truck',
    route: 'apps/vehicles',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/vehicles/list',
      },
    ],
  },
  {
    displayName: 'Drivers',
    iconName: 'user',
    route: 'apps/drivers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/drivers/list',
      },
      {
        displayName: 'Pending Orders',
        iconName: 'point',
        route: 'apps/drivers/pending-orders',
      },
    ],
  },
  {
    displayName: 'Payments',
    iconName: 'moneybag',
    route: 'apps/payments',
    children: [
      {
        displayName: 'Payment List',
        iconName: 'point',
        route: 'apps/payments/payments',
      },
      {
        displayName: 'Payment Methods',
        iconName: 'point',
        route: 'apps/payments/methods',
      },
      {
        displayName: 'Credit Payments Aging',
        iconName: 'point',
        route: 'apps/reports/credit-payments-aging-report',
      },
      {
        displayName: 'Driver Retailer Visits',
        iconName: 'point',
        route: 'apps/reports/driver-retailer-visits-report',
      },
    ],
  },
  {
    displayName: 'Reports',
    iconName: 'chart-infographic',
    route: 'apps/reports',
    children: [
      {
        displayName: 'Daily Summary',
        iconName: 'point',
        route: 'apps/reports/daily-summary-report',
      },
      {
        displayName: 'Monthly Bales Delivered',
        iconName: 'point',
        route: 'apps/reports/monthly-bales-delivered-report',
      },
      {
        displayName: 'Monthly Bales Deviation',
        iconName: 'point',
        route: 'apps/reports/monthly-bales-deviation-report',
      },
      {
        displayName: 'Driver MTD Performance',
        iconName: 'point',
        route: 'apps/reports/monthly-driver-mtd-report',
      },
      {
        displayName: 'Hub & Spoke MTD Summary',
        iconName: 'point',
        route: 'apps/reports/monthly-hub-mtd-report',
      },
      {
        displayName: 'Hub & Spoke Summary',
        iconName: 'point',
        route: 'apps/reports/monthly-hub-summary-report',
      },
      {
        displayName: 'Yearly Monthly Performance',
        iconName: 'point',
        route: 'apps/reports/yearly-monthly-performance-report',
      },
      {
        displayName: 'Products Sold',
        iconName: 'point',
        route: 'apps/reports/products-sold-report',
      },
      {
        displayName: 'Orders Report',
        iconName: 'point',
        route: 'apps/reports/hub-completed-orders-report',
      },
      {
        displayName: 'Sales Report',
        iconName: 'point',
        route: 'apps/reports/income-report',
      },
      {
        displayName: 'Driver Commission',
        iconName: 'point',
        route: 'apps/reports/driver-commission',
      },
      {
        displayName: 'Hub Commission',
        iconName: 'point',
        route: 'apps/reports/hub-commission',
      },
      {
        displayName: 'Payment Methods',
        iconName: 'point',
        route: 'apps/reports/payment-methods-report',
      },
      {
        displayName: 'Credit Payments Aging',
        iconName: 'point',
        route: 'apps/reports/credit-payments-aging-report',
      },
      {
        displayName: 'Driver Retailer Visits',
        iconName: 'point',
        route: 'apps/reports/driver-retailer-visits-report',
      },
    ],
  },
];
